// GTM dataLayer utilities for GA4 ecommerce tracking

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

// Helper para limpiar el ecommerce anterior antes de un nuevo evento
const clearEcommerce = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
};

// Evento: page_view (para SPA - navegación virtual)
export const trackPageView = (pageData: {
  page_path: string;
  page_title: string;
  page_location: string;
}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'page_view',
    page_path: pageData.page_path,
    page_title: pageData.page_title,
    page_location: pageData.page_location,
  });
};

// Evento: view_item (cuando el usuario ve un producto)
export const trackViewItem = (product: {
  id: string;
  name: string;
  price: number;
  brand?: string;
  category?: string;
  variant?: string;
}) => {
  clearEcommerce();
  window.dataLayer.push({
    event: 'view_item',
    ecommerce: {
      currency: 'CRC',
      value: product.price,
      items: [{
        item_id: product.id,
        item_name: product.name,
        item_brand: product.brand || '',
        item_category: product.category || '',
        item_variant: product.variant || '',
        price: product.price,
        quantity: 1,
      }]
    }
  });
};

// Evento: add_to_cart
export const trackAddToCart = (product: {
  id: string;
  name: string;
  price: number;
  brand?: string;
  category?: string;
  variant?: string;
  quantity?: number;
}) => {
  clearEcommerce();
  window.dataLayer.push({
    event: 'add_to_cart',
    ecommerce: {
      currency: 'CRC',
      value: product.price * (product.quantity || 1),
      items: [{
        item_id: product.id,
        item_name: product.name,
        item_brand: product.brand || '',
        item_category: product.category || '',
        item_variant: product.variant || '',
        price: product.price,
        quantity: product.quantity || 1,
      }]
    }
  });
};

// Evento: begin_checkout (cuando el usuario inicia el checkout)
export const trackBeginCheckout = (cart: {
  value: number;
  items: Array<{
    id: string;
    name: string;
    price: number;
    quantity: number;
    variant?: string;
  }>;
}) => {
  clearEcommerce();
  window.dataLayer.push({
    event: 'begin_checkout',
    ecommerce: {
      currency: 'CRC',
      value: cart.value,
      items: cart.items.map(item => ({
        item_id: item.id,
        item_name: item.name,
        item_variant: item.variant || '',
        price: item.price,
        quantity: item.quantity,
      }))
    }
  });
};

// Evento: purchase
export const trackPurchase = (order: {
  orderNumber: string;
  total: number;
  subtotal: number;
  discount: number;
  items: Array<{
    id: string;
    name: string;
    price: number;
    quantity: number;
    variant?: string;
  }>;
}) => {
  clearEcommerce();
  window.dataLayer.push({
    event: 'purchase',
    ecommerce: {
      transaction_id: order.orderNumber,
      value: order.total,
      currency: 'CRC',
      discount: order.discount,
      items: order.items.map(item => ({
        item_id: item.id,
        item_name: item.name,
        item_variant: item.variant || '',
        price: item.price,
        quantity: item.quantity,
      }))
    }
  });
};
